/* eslint-disable max-lines */
import { GET_USER_PROFILE_SUCCESS } from '../user/types';
import * as c from './types';
import createApiAction from '../../api/createApiAction';
import history from '../../utils/history';
import toastr from '../../utils/toastr';
import { I18n } from '../../utils/i18n';
import { getUserProfile } from '../user/actions';
import { AnyTypeToFix } from '../../types/anytype';
import { sessionService } from 'redux-react-session';

export const login = (data: { email: string; password: string }) =>
  createApiAction({
    method: 'login',
    requestAction: c.LOGIN_REQUEST,
    successAction: c.LOGIN_SUCCESS,
    params: data,
    errorHandler(
      dispatch: AnyTypeToFix,
      { response }: { response: AnyTypeToFix }
    ) {
      const errorMessage =
        response?.status !== 401
          ? response?.data?.error
          : I18n.t('invalidCredentialsWrongEmailOrPassword_popup');
      toastr.error(I18n.t('system_popup'), errorMessage);

      // EDIT THIS \\

      dispatch({
        type: c.LOGIN_ERROR,
        payload: errorMessage
      });
    },
    transformResponse: ({ data }: { data: AnyTypeToFix }) => data,
    afterSuccess: (
      dispatch: AnyTypeToFix,
      {
        data: {
          jwt: { token },
          ...userData
        }
      }: { data: AnyTypeToFix }
    ) => {
      sessionService.saveSession({ token });
      sessionService.saveUser(userData);
      dispatch(getUserProfile(userData));
      dispatch({
        type: GET_USER_PROFILE_SUCCESS,
        payload: userData
      });
    }
  });

export const register = (data: {
  email: string;
  password: string;
  identityType: string;
}) =>
  createApiAction({
    method: 'register',
    requestAction: c.REGISTER_REQUEST,
    successAction: c.REGISTER_SUCCESS,
    errorAction: c.REGISTER_ERROR,
    params: data,
    errorHandler(
      dispatch: AnyTypeToFix,
      { response }: { response: AnyTypeToFix }
    ) {
      const errorMessage = response?.data?.error;
      toastr.error(I18n.t('system_popup'), errorMessage);
      dispatch({
        type: c.REGISTER_ERROR,
        payload: errorMessage
      });
    },
    transformResponse: () => data,
    afterSuccess: (
      dispatch: AnyTypeToFix,
      {
        data: {
          jwt: { token },
          ...userData
        }
      }: AnyTypeToFix
    ) => {
      sessionService.saveSession({ token });
      sessionService.saveUser(userData);
      dispatch(getUserProfile(userData));
    }
  });

export const logout = () =>
  createApiAction({
    method: 'logout',
    requestAction: c.LOGOUT_REQUEST,
    successAction: c.LOGOUT_SUCCESS,
    errorHandler(dispatch: AnyTypeToFix, { response }: AnyTypeToFix) {
      const errorMessage = response?.data?.error;
      toastr.error(I18n.t('system_popup'), errorMessage);
      dispatch({
        type: c.LOGOUT_ERROR,
        payload: errorMessage
      });
    },
    transformResponse: ({ data }: AnyTypeToFix) => data,
    afterSuccess: () => {
      sessionService.deleteSession();
      sessionService.deleteUser();
      window.localStorage.removeItem('stop-classification-filters');
      window.location.reload();
    }
  });

export const forgotPassword = (data: {
  email: string;
  redirectUrl: string;
  resetParameter: string;
}) =>
  createApiAction({
    method: 'forgotPassword',
    requestAction: c.FORGOT_PASSWORD_REQUEST,
    successAction: c.FORGOT_PASSWORD_SUCCESS,
    params: data,
    errorHandler(dispatch: AnyTypeToFix, { response }: AnyTypeToFix) {
      const errorMessage = response?.data?.error;
      toastr.error(I18n.t('system_popup'), errorMessage);
      toastr.error(I18n.t('system_popup'), errorMessage);

      dispatch({
        type: c.FORGOT_PASSWORD_ERROR,
        payload: errorMessage
      });
    },
    transformResponse: ({ data }: AnyTypeToFix) => data,
    afterSuccess: () =>
      toastr.success(
        I18n.t('system_popup'),
        I18n.t('resetPasswordEmailWasSent_popup')
      )
  });

export const resetPassword = (data: AnyTypeToFix) =>
  createApiAction({
    method: 'resetPassword',
    requestAction: c.RESET_PASSWORD_REQUEST,
    successAction: c.RESET_PASSWORD_SUCCESS,
    params: data,
    errorHandler(dispatch: AnyTypeToFix, { response }: AnyTypeToFix) {
      const errorMessage = response?.data?.error;
      toastr.error(I18n.t('system_popup'), errorMessage);
      dispatch({
        type: c.RESET_PASSWORD_ERROR,
        payload: errorMessage
      });
    },
    transformResponse: ({ data }: AnyTypeToFix) => data,
    afterSuccess: () => {
      history.push('/');
      toastr.success(
        I18n.t('system_popup'),
        I18n.t('passwordWasSuccessfullyChanged_popup')
      );
    }
  });

export const registerRequest = () => ({
  type: c.REGISTER_REQUEST
});

export const registerSuccess = (payload: AnyTypeToFix) => ({
  type: c.REGISTER_SUCCESS,
  payload
});

export const registerError = (payload: AnyTypeToFix) => ({
  type: c.REGISTER_ERROR,
  payload
});

export const forgotPasswordRequest = () => ({
  type: c.FORGOT_PASSWORD_REQUEST
});

export const forgotPasswordSuccess = (payload: AnyTypeToFix) => ({
  type: c.FORGOT_PASSWORD_SUCCESS,
  payload
});

export const forgotPasswordError = (payload: AnyTypeToFix) => ({
  type: c.FORGOT_PASSWORD_ERROR,
  payload
});

export const resetPasswordRequest = () => ({
  type: c.RESET_PASSWORD_REQUEST
});

export const resetPasswordSuccess = (payload: AnyTypeToFix) => ({
  type: c.RESET_PASSWORD_SUCCESS,
  payload
});

export const resetPasswordError = (payload: AnyTypeToFix) => ({
  type: c.RESET_PASSWORD_ERROR,
  payload
});
